import {Injectable} from '@angular/core';
import {FeatureToggleService} from "@seniorsistemas/platform-components";

import {Observable} from 'rxjs';


@Injectable({
	providedIn: 'root'
})
export class AnalyticsFeatureToggleService {

	constructor(private readonly featureToggleService: FeatureToggleService) {
	}

	public isRemunerationFeatureEnabled(featureName: string): Observable<boolean> {
		return this.featureToggleService.isEnabled({
			domain: 'hcm',
			service: 'remuneration',
			name: featureName.valueOf()
		});
	}

	public isNewAnalyticsEnabled(): Observable<boolean> {
		return this.featureToggleService.isEnabled({
			domain: 'hcm',
			service: 'hcm_remuneration_analytics',
			name: 'remunera-new-analytics'
		});
	}
}

